import React from 'react';
import '../pages/printable-map-shell.css';

/**
 * The Review & Print still of the sheet the user already approved.
 * It must not call the preview API — that image was captured on step 3.
 */
export function PrintableMapFrozenPreview({
  snapshot,
  title,
  size,
  frameHeight = 380,
}) {
  if (!snapshot?.image) {
    return (
      <p className="pm-field-help mb-0" data-testid="pm-frozen-preview-missing">
        Go back to Preview to render the sheet before downloading.
      </p>
    );
  }

  const fallbackAspect = snapshot.orientation === 'landscape' ? 4 / 3 : 3 / 4;
  const aspect = snapshot.width && snapshot.height
    ? snapshot.width / snapshot.height
    : fallbackAspect;

  return (
    <div className="d-flex flex-column align-items-center gap-2" data-testid="pm-frozen-preview">
      <div
        className="pm-frozen-sheet"
        style={{
          width: Math.round(frameHeight * aspect),
          height: frameHeight,
        }}
      >
        <img
          src={snapshot.image}
          alt={title?.trim() ? `Approved print preview of ${title.trim()}` : 'Approved print preview'}
        />
      </div>
      {snapshot.acres != null && snapshot.effective_dpi != null ? (
        <div className="text-center">
          <div className="pm-mono-label">
            {`${Number(snapshot.acres).toLocaleString()} ACRES · ${snapshot.effective_dpi} DPI`}
          </div>
          {snapshot.is_native_resolution === false ? (
            <div className="small text-warning mt-1">
              This property is small for a {String(size || '').replace('x', ' × ')}″ print, so
              imagery is being enlarged. A smaller size will look sharper.
            </div>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
